import { Resource } from 'i18next'
import en from './en.json'
import fr from './fr.json'
import ru from './ru.json'

export default {
    en,
    ru,
    fr
} as Resource
